export default "/images/1038027d10b7303fd8d67dd94a74b226.avif";